
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type fitmentTableRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function fitmentTableRT(): TemplateResult<fitmentTableRTRootProps> {
    function mergeProps(inline, external) {
        var res = Object.assign({}, inline, external);
        if (inline.hasOwnProperty('style')) {
            res.style = _.defaults(res.style, inline.style);
        }
        if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
            res.className = external.className + ' ' + inline.className;
        }
        return res;
    }
    function repeatField2(field, fieldIndex) {
        return _createElement('div', {
            'className': 'fitment-cell fitment-field-' + field.toLowerCase(),
            'key': field
        }, _createElement('div', mergeProps({ 'className': 'fitment-cell__value' }, { dangerouslySetInnerHTML: { __html: typeof field === 'undefined' ? '' : field } })));
    }
    function repeatItems3(items, itemsIndex) {
        return [items(function () {
                return _createElement('div', { 'className': 'fitment-row' }, _createElement('div', { 'className': 'fitment-cell fitment-field-year' }, this.fitment.Year), _createElement('div', { 'className': 'fitment-cell fitment-field-make' }, this.fitment.Make), _createElement('div', { 'className': 'fitment-cell fitment-field-model' }, this.fitment.Model));
            }, { count: undefined })];
    }
    return !this.noFitmentData ? _createElement('div', {
        'className': 'cm_fitment-table fitment-table-container',
        'key': '0'
    }, this.manyFitments ? _createElement('div', {
        'className': 'fitment-table-title many-fitments',
        'key': '86'
    }, '\n    ', _translate(`fitment_table_many_fitments`), '\n  ') : null, this.universalFit ? _createElement('div', {
        'className': 'fitment-table-title universal-fit',
        'key': '220'
    }, 'Universal Fit') : null, [_createElement('div', {
            'className': 'fitment-table-body fitment-table-header',
            'key': '3150'
        }, _createElement.apply(this, [
            'div',
            { 'className': 'fitment-row' },
            _map(this.fields, repeatField2.bind(this))
        ]))], _createElement.apply(this, [
        'div',
        { 'className': 'fitment-table-body fitment-table-fitment cmRepeater_items' },
        _map(this.items, repeatItems3.bind(this))
    ])) : null;
}
        export const componentNames = []